module.exports = __webpack_public_path__ + "static/media/09hu.d18a5885.png";